/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-09 13:58:05
 *
 *******************************************************/
// @flow

import type { ThemeRevertState, ThemeRevertAction } from 'stores/flow-type/theme-revert.type';

import {
  REVERT_THEME_REQUEST,
  REVERT_THEME_SUCCESS,
  REVERT_THEME_FAILURE,
  REVERT_THEME_FEEDBACK_REQUEST,
  REVERT_THEME_FEEDBACK_SUCCESS,
  REVERT_THEME_FEEDBACK_FAILURE,
  REVERT_THEME_MANUAL_CONTACT_REQUEST,
  REVERT_THEME_MANUAL_CONTACT_SUCCESS,
  REVERT_THEME_MANUAL_CONTACT_FAILURE,
  RESET_THEME_REVERT
} from 'stores/flow-type/theme-revert.type';

const initialState: ThemeRevertState = {
  loading: false,
  success: false,
  revertThemeId: 0,
  removeSearchOnly: false,
  revertThemeError: undefined,
  feedbackLoading: false,
  feedbackSuccess: false,
  error: undefined
};

const themeRevertReducers = (state: ThemeRevertState = initialState, action: ThemeRevertAction) => {
  switch (action.type) {
    case REVERT_THEME_REQUEST:
      return { ...state, loading: true, success: false, revertThemeError: undefined };
    case REVERT_THEME_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,

        revertThemeError: undefined,
        error: undefined
      };
    }
    case REVERT_THEME_FAILURE:
      const { themeId, removeSearchOnly = false } = action.payload;
      return {
        ...state,
        loading: false,
        success: false,
        revertThemeId: themeId,
        removeSearchOnly,
        revertThemeError: action.payload,
        error: action.payload
      };

    case REVERT_THEME_FEEDBACK_REQUEST:
      return { ...state, feedbackLoading: true, feedbackSuccess: false, error: undefined };
    case REVERT_THEME_FEEDBACK_SUCCESS: {
      return {
        ...state,
        feedbackLoading: false,
        feedbackSuccess: true,
        error: undefined
      };
    }
    case REVERT_THEME_FEEDBACK_FAILURE:
      return {
        ...state,
        feedbackLoading: false,
        feedbackSuccess: false,
        error: action.payload
      };

    case REVERT_THEME_MANUAL_CONTACT_REQUEST:
      return { ...state, manualContactLoading: true, manualContactSuccess: false, manualContactError: undefined };
    case REVERT_THEME_MANUAL_CONTACT_SUCCESS: {
      return {
        ...state,
        manualContactLoading: false,
        manualContactSuccess: true,
        manualContactError: undefined
      };
    }
    case REVERT_THEME_MANUAL_CONTACT_FAILURE:
      return {
        ...state,
        manualContactLoading: false,
        manualContactSuccess: false,
        manualContactError: action.payload
      };

    case RESET_THEME_REVERT:
      return initialState;
    default:
      return state;
  }
};
export default themeRevertReducers;
